export interface Attestation {
  id: number;
  documentSlug: string;
  documentUrl: string;
  documentTitle: string;
  agreedAt: string;
  agreedIp: string;
  agreedUa: string;
}

/** `document_slug` of the Financial Responsibility Agreement attestation (`ClientAttestation::DOCUMENTS`). */
export const FINANCIAL_AGREEMENT_DOCUMENT_SLUG = 'financial_responsibility_agreement';
